import { PropsWithChildren, createContext, useState } from 'react';

type Layout = {
  isMenuOpen: boolean;
  sidebar: boolean;
  toolbar: boolean;
  footer: boolean;
};
type LayoutContextType = {
  layout: Layout;
  setLayout: React.Dispatch<React.SetStateAction<Layout>>;
};

export const LayoutContext = createContext<LayoutContextType>(
  undefined as unknown as LayoutContextType,
);

const LayoutProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [layout, setLayout] = useState<Layout>({
    sidebar: true,
    toolbar: true,
    footer: true,
    isMenuOpen: true,
  });

  return (
    <LayoutContext.Provider value={{ layout, setLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};

export default LayoutProvider;
